module.exports = __webpack_public_path__ + "static/media/corporate-services-img11.f96bbb73.jpg";